import React, { useState,useEffect } from "react";
import Home from './Components/base/Home';
import LoginForm from './Components/base/Login';
import Maintenance from './Components/base/Maintenance';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import "./utils/interceptor"
import { ToastContainer } from 'react-toastify';

const App = () => {
    const isMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
    const [validB2CUser, setValidB2CUser] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            const currentPath = window.location.pathname;
            const token = sessionStorage.getItem("Token");
            const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
 
            if (token && isLoggedIn) {
                setValidB2CUser(true);
                if (currentPath === "/") {
                    setValidB2CUser(false);
                }
            } else {
                setValidB2CUser(false);
            }
            setLoading(false);
        };
        checkAuth();
    }, []);
    if (isMaintenance) {
        return <Maintenance />;
    }

    const currentPath = window.location.pathname;
    if (currentPath === "/") {  
        return <LoginForm setValidB2CUser={setValidB2CUser} />;
    }
    return (

        <React.Fragment>
            <AuthenticatedTemplate>
                {console.log("validB2CUser",validB2CUser)}
                {validB2CUser === true && (
                    <Home setIsAuthenticated={setIsAuthenticated}/>
                )
                }
                {validB2CUser === false && (
                    <>
                    <LoginForm setValidB2CUser={setValidB2CUser} setIsAuthenticated={setIsAuthenticated} />
                  </>
                )}

            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                {console.log("invalidB2CUser",validB2CUser)}
                {validB2CUser === true && (
                    <Home />
                )
                }
                {validB2CUser === false && (
                    <>
                 <LoginForm setValidB2CUser={setValidB2CUser} />
                     {/* <ToastContainer
                              autoClose={process.env.TOAST_AUTO_CLOSE}
                              className="toast-container"
                              hideProgressBar={true}
                              newestOnTop={false}
                              rtl={false}
                              pauseOnFocusLoss
                              draggable
                              pauseOnHover
                              closeButton={false}
                              theme="colored"
                              icon={false}
                            /> */}
                            </>
                )}
            </UnauthenticatedTemplate>
        </React.Fragment>


    );
};

export default App;
